<template>
	<!-- a raw data report always has its own quick filter, a custom data one gets it as well, also inside a workbook -->
	<report-preview-custom-data
		v-if="report && hasCustomData"
		:report="report"
		:showQuickFilter="true"
	/>
	<report-preview-raw-data
		v-else-if="report"
		:report="report"
		:workbook="workbook"
	/>
</template>
<script>
import ReportPreviewRawData from './ReportPreviewRawData.vue';
import ReportPreviewCustomData from './ReportPreviewCustomData.vue';
import { ReportPreviewActions } from '../../../../../store/actions';
import { reportTypes } from '../../../../../enums/reportTypes';
export default {
	name: 'ReportPreview',
	components: {
		ReportPreviewRawData,
		ReportPreviewCustomData,
	},
	props: {
		report: Object,
		workbook: Object,
	},
	computed: {
		hasCustomData() {
			if (!this.report) return false;
			return this.report.Type == reportTypes.CUSTOM_DATA;
		},
	},
	mounted() {
		this.$store.dispatch(ReportPreviewActions.LOAD_REPORT, {
			report: this.report,
			workbook: this.workbook,
		});
	},
	destroyed() {
		if (!this.workbook) {
			this.$store.dispatch(ReportPreviewActions.CLEAR);
		}
	},
};
</script>
